// extracted by mini-css-extract-plugin
module.exports = {"container":"WebphonePlaceholder_container__Ag_QN"};